/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_In_House_OnlyInputs */

const en_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-house Only`)
};

const es_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo internos`)
};

const fr_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne uniquement`)
};

const de_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur In-House`)
};

const ja_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`専属業者のみ`)
};

const zh_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限内部供应商`)
};

const ar_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خدمات داخلية فقط`)
};

const id_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Internal`)
};

const it_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo Personale Interno`)
};

const ru_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только штатный поставщик`)
};

const pt_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas Interno`)
};

const ko_val_in_house_only = /** @type {(inputs: Val_In_House_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사내 서비스만 이용`)
};

/**
* | output |
* | --- |
* | "In-house Only" |
*
* @param {Val_In_House_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_in_house_only = /** @type {((inputs?: Val_In_House_OnlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_In_House_OnlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_in_house_only(inputs)
	if (locale === "es") return es_val_in_house_only(inputs)
	if (locale === "fr") return fr_val_in_house_only(inputs)
	if (locale === "de") return de_val_in_house_only(inputs)
	if (locale === "ja") return ja_val_in_house_only(inputs)
	if (locale === "zh") return zh_val_in_house_only(inputs)
	if (locale === "ar") return ar_val_in_house_only(inputs)
	if (locale === "id") return id_val_in_house_only(inputs)
	if (locale === "it") return it_val_in_house_only(inputs)
	if (locale === "ru") return ru_val_in_house_only(inputs)
	if (locale === "pt") return pt_val_in_house_only(inputs)
	return ko_val_in_house_only(inputs)
});